<template>
    <v-card class="mt-2">
        <div class="d-flex align-center" :class="color">
            <v-card-title>
                <slot></slot>
            </v-card-title>

            <div class="pa-1 ms-auto">
                <span class="v-app-tooltip-btn d-inline-block">
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn rounded icon v-on="on" @click="expandAll">
                                <v-icon>mdi-arrow-expand</v-icon>
                            </v-btn>
                        </template>
                        Expand All
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn rounded icon v-on="on" @click="collapseAll">
                                <v-icon>mdi-arrow-collapse</v-icon>
                            </v-btn>
                        </template>
                        Collapse All
                    </v-tooltip>
                </span>
            </div>
        </div>
        <v-card-text>
            <v-expansion-panels v-model="panels" focusable multiple>
                <v-expansion-panel v-for="flight in flights" :key="flight.id">
                    <v-expansion-panel-header>
                        <v-row no-gutters>
                            <v-col cols="8">
                                <div class="d-flex">
                                    <copy-value
                                        v-if="$store.state.debugMode"
                                        :value="flight.id.toString()"
                                        class="mr-2"
                                    >
                                        #{{ flight.id }}
                                    </copy-value>

                                    <div v-if="flight.starts_at">
                                        <datetime-display
                                            :datetime="flight.starts_at"
                                            format="ddd h:mm a"
                                            :timezone="meet.timezone"
                                            class="grey--text text--darken-2 font-weight-bold"
                                        />
                                    </div>
                                </div>

                                <v-row v-if="false">
                                    <v-col>
                                        <v-progress-linear
                                            :value="flight.completed_percent"
                                            color="primary"
                                            class="mt-2"
                                        />
                                    </v-col>
                                    <v-col> {{ Math.ceil(flight.completed_percent) }}% </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <start-list :start-lists="flight.start_lists" :flight-event="flight.event" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-card-text>
    </v-card>
</template>

<script>
import StartList from '@/Components/StartList.vue';
import DatetimeDisplay from '@/Components/DatetimeDisplay.vue';
import Meet from '@/Models/Meet.js';
import CopyValue from '@/Components/CopyValue.vue';

export default {
    name: 'FlightStartList',

    components: { CopyValue, DatetimeDisplay, StartList },

    inject: ['sharedState'],

    props: {
        flights: {
            type: Array,
            required: true,
        },

        meet: {
            type: Meet,
            required: true,
        },

        event: {
            type: String,
            required: false,
            default: '',
        },

        searching: {
            type: Boolean,
            required: false,
        },
    },

    data: () => ({
        panels: [],
    }),

    computed: {
        someAreOpen() {
            return this.panels.length > 0;
        },

        noneAreOpen() {
            return this.panels.length === 0;
        },

        color() {
            return (
                {
                    TI: `blue ${this.$vuetify.theme.dark ? 'darken-4' : 'lighten-4'}`,
                    DM: `green ${this.$vuetify.theme.dark ? 'darken-4' : 'lighten-4'}`,
                    TU: `red ${this.$vuetify.theme.dark ? 'darken-4' : 'lighten-4'}`,
                    TS: `yellow ${this.$vuetify.theme.dark ? 'darken-4' : 'lighten-4'}`,
                }[this.event] || ''
            );
        },
    },

    watch: {
        flights() {
            if (this.searching) {
                this.$nextTick(() => this.expandAll());
            }
        },
    },

    created() {
        if (this.searching) {
            this.expandAll();
        }
    },

    methods: {
        has: _.has,

        expandAll() {
            this.panels = [...this.flights.keys()].map((k, i) => i);
        },

        collapseAll() {
            this.panels = [];
        },
    },
};
</script>
